import api from './api';

export const uploadService = {
  uploadPaymentProof: async (file: File, paymentId?: number) => {
    const formData = new FormData();
    formData.append('file', file);
    
    if (paymentId) {
      formData.append('payment_id', paymentId.toString());
    }
    
    const response = await api.post('/upload/payment-proof', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / (progressEvent.total || 1)
        );
        // Puedes usar esto para mostrar barra de progreso
        console.log(`Upload progress: ${percentCompleted}%`);
      },
    });
    
    return response.data;
  },

  deletePaymentProof: async (fileUrl: string, paymentId: number) => {
    const response = await api.delete('/upload/payment-proof', {
      data: { file_url: fileUrl, payment_id: paymentId }
    });
    return response.data;
  }
};